export const handleCompanyName = (
  id: number,
  name: string | null | undefined,
) => {
  return name ? name : `Company #${id}`;
};

export const handleCompanyUserName = (
  id: number,
  name: string | null | undefined,
) => {
  return name ? name : `Company User #${id}`;
};
